import ReCAPTCHA from 'react-google-recaptcha';
import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const NamePhoneForm = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const namePhoneTemplates = {
    first: css`
        grid-template-columns: repeat(2, minmax(224px, 288px)) min-content;
        grid-template-areas:
            "name phone button"
            "policynote policynote policynote";
    `,
    second: css`
        grid-template-columns: repeat(2, minmax(224px, 288px));
        grid-template-areas:
            "name phone"
            "policynote policynote"
            "button button";
    `,
    mobile: css`
        grid-template-columns: minmax(224px, 1fr);
        grid-template-areas:
            "name"
            "phone"
            "recaptcha"
            "policynote"
            "button";
    `,
};

const recaptchaNamePhoneTemplates = {
    first: css`
        grid-template-columns: repeat(2, minmax(224px, 288px)) min-content;
        grid-template-areas:
            "name phone button"
            "policynote policynote policynote"
            "recaptcha recaptcha recaptcha";
    `,
    second: css`
        grid-template-columns: repeat(2, minmax(224px, 288px));
        grid-template-areas:
            "name phone"
            "policynote policynote"
            "button button"
            "recaptcha recaptcha";
    `,
    mobile: css`
        grid-template-columns: minmax(224px, 1fr);
        grid-template-areas:
            "name"
            "phone"
            "recaptcha"
            "policynote"
            "button";
    `,
};

const phoneTemplates = {
    first: css`
        grid-template-columns: minmax(224px, 288px) min-content;
        grid-template-areas:
            "phone button"
            "policynote policynote";
    `,
    second: css`
        grid-template-columns: repeat(2, minmax(224px, 288px));
        grid-template-areas:
            "phone phone"
            "policynote policynote"
            "button button";
    `,
    mobile: css`
        grid-template-columns: minmax(224px, 1fr);
        grid-template-areas:
            "phone"
            "policynote"
            "button";
    `,
};

const recaptchaPhoneTemplates = {
    first: css`
        grid-template-columns: minmax(224px, 288px) min-content;
        grid-template-areas:
            "phone button"
            "policynote policynote"
            "recaptcha recaptcha";
    `,
    second: css`
        grid-template-columns: repeat(2, minmax(224px, 288px));
        grid-template-areas:
            "phone phone"
            "policynote policynote"
            "button button"
            "recaptcha recaptcha";
    `,
    mobile: css`
        grid-template-columns: minmax(224px, 1fr);
        grid-template-areas:
            "phone"
            "recaptcha"
            "policynote"
            "button";
    `,
};

export type TTemplate = keyof typeof namePhoneTemplates;

export const GridTemplate = styled.div<{variant: TTemplate, isOnlyPhone: boolean, isRecaptcha: boolean}>`
    display: grid;
    grid-gap: 12px 8px;
    grid-auto-rows: min-content;
    align-items: flex-start;
    ${p => p.isOnlyPhone
        ? p.isRecaptcha ? recaptchaPhoneTemplates[p.variant] : phoneTemplates[p.variant]
        : p.isRecaptcha ? recaptchaNamePhoneTemplates[p.variant] : namePhoneTemplates[p.variant]
    };
`;

const Input = styled(InputSimple)`
    margin-bottom: 0;

    [data-test="placeholder"] {
        display: none;
    }

    [class*="InputError"] {
        padding: 0 5px;
        white-space: nowrap;
    }
`;

const NameField = styled(Input)`
    grid-area: name;
`;

const PhoneField = styled(Input)`
    grid-area: phone;
`;

export const InputName = nameDecorator(NameField);

export const InputPhone = phoneDecorator(PhoneField);

export const Button = styled(BaseButton)`
    grid-area: button;
    width: 195px;
    flex: 1 0 auto;
`;

export const PolicyNoteWrapper = styled.div<{invertColor?: boolean}>`
    color: ${p => p.invertColor ? COLORS.TextWhite : COLORS.TextSecondary};
    grid-area: policynote;
    margin-left: 0;
`;

export const Captcha = styled(ReCAPTCHA)`
    grid-area: recaptcha;
`;
